import { useCallback } from 'react'

type TValidationRule<T> = (value: T) => string | Promise<string>
interface IUseValidation<T> {
  rules: TValidationRule<T> | TValidationRule<T>[]
  isPassed?: boolean
}

export const useValidation = <T>({ rules, isPassed }: IUseValidation<T>) => {
  return useCallback(
    async (value: T) => {
      if (isPassed) {
        return ''
      }

      if (Array.isArray(rules)) {
        const result = await Promise.all(
          rules.map((rule) => {
            return rule(value)
          })
        )

        return result.find((m) => m.length) || ''
      } else {
        return rules(value)
      }
    },
    [isPassed, rules]
  )
}
